import { useEffect, useRef, useState } from "react";
import Loading from "../../common/components/Loading";
import Button from "../../theme/components/Button";
import SearchField from "../../theme/components/SearchField";
import useOwnClients from "../hooks/useOwnClients";
import { useTranslations } from "next-intl";
import useCurrentUser from "../../auth/hooks/useCurrentUser";
import Icon from "../../common/components/Icon";
const CartItemsCount = ({ items }) => {
  if (!items?.length) return null;
  const cartItemCount = items?.reduce(
    (currentValue, item) => currentValue + item.quantity,
    0,
  );
  return (
    <div className="d-flex align-items-center">
      <Icon icon="cart" />
      {cartItemCount}
    </div>
  );
};
const ClientChooser = ({
  onSelected,
  showCartItemsCount = false,
  defaultOpen = false,
  showInstitutions = false,
}) => {
  const t = useTranslations();
  const [queryString, setQueryString] = useState(null);
  const rowRef = useRef<HTMLDivElement | null>(null);
  const { ownClients, institutionClients } = useOwnClients({ queryString });
  const { currentUser, loading } = useCurrentUser();
  const [isOpen, setOpen] = useState<boolean>(defaultOpen);

  const selectableClients = !currentUser?.self?.isPrivateCustomer
    ? ownClients?.filter((t) => !t.isInstitution)
    : [currentUser?.self]?.filter((t) => !t.isInstitution);
  useEffect(() => {
    if (currentUser?.self?.isPrivateCustomer) {
      onSelected(currentUser?.self);
    }
  }, [currentUser, loading]);
  if (currentUser?.self?.isPrivateCustomer) return null;

  return (
    <div className={`my-1`}>
      <SearchField
        placeholder={t("filter_client")}
        updateOnChange
        defaultValue={queryString}
        onSearch={setQueryString}
        onFocus={() => setOpen(true)}
        onBlur={(e) => {
          if (
            rowRef.current &&
            rowRef.current.contains(e.relatedTarget as Node)
          ) {
            return;
          }
          setOpen(false);
        }}
      />
      {isOpen && !loading && (
        <div className="d-block w-100 z-3 left-0 right-0 bg-white" ref={rowRef}>
          {loading && <Loading />}
          {showInstitutions && !!institutionClients?.length && (
            <>
              {!loading && (
                <div className="mt-3 color-secondary fs-8 mt-4">
                  {t("institutions")}
                </div>
              )}
              <ul className="px-0 client-list-item-wrapper">
                {institutionClients.map((client) => (
                  <li key={`search-match-${client._id}`}>
                    <Button
                      key={client._id}
                      appearance="link"
                      onClick={(e) => {
                        setQueryString(client.name);
                        onSelected?.(client);
                      }}
                      className="d-block w-100 py-1 py-xl-0 px-3"
                    >
                      <div className="d-flex justify-content-between align-items-center cursor-pointer">
                        <div
                          className={`align-items-center d-flex ${currentUser?.currentClient?._id === client?._id ? "fw-bolder" : ""}`}
                        >
                          {client?.isInstitution && <Icon icon="building" />}
                          {client.name}
                        </div>
                        {showCartItemsCount && (
                          <CartItemsCount items={client?.cart?.items} />
                        )}
                      </div>
                    </Button>
                  </li>
                ))}
              </ul>
            </>
          )}
          {showInstitutions && !!selectableClients?.length && (
            <div className="mt-3 color-secondary fs-8 mt-4">{t("clients")}</div>
          )}
          <ul
            className={`px-0 client-list-item-wrapper ${!showInstitutions ? "drop-shadow border-radius" : ""}`}
          >
            {selectableClients
              .filter((t) => !t.isInstitution)
              .map((client) => (
                <li key={`search-match-${client._id}`}>
                  <Button
                    key={client._id}
                    appearance="link"
                    onClick={() => {
                      setQueryString(client.name);
                      onSelected?.(client);
                      setOpen(false);
                    }}
                    className="d-block w-100 py-1 py-lg-0 px-3"
                  >
                    <div
                      className={`d-flex justify-content-between align-items-center cursor-pointer  ${currentUser?.currentClient?._id === client?._id ? "fw-bolder" : ""} `}
                    >
                      {client.name}
                      {showCartItemsCount && (
                        <CartItemsCount items={client?.cart?.items} />
                      )}
                    </div>
                  </Button>
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ClientChooser;
